import { useState } from 'react';
import './StorageNotice.css';

const NOTICE_KEY = 'smg:storage-notice:v1';

/** Disclosure only. Dismissal must never enable analytics or count as consent. */
export default function StorageNotice() {
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(NOTICE_KEY) === 'dismissed'; }
    catch { return false; }
  });
  if (dismissed) return null;
  return (
    <aside className="storage-notice" aria-label="Cookies and storage notice">
      <div>
        <strong>Cookies &amp; app storage</strong>
        <p>We use storage for sign-in, settings and offline features. Optional Google Analytics is off.
          {' '}<a href="/legal/cookies.html" target="_blank" rel="noopener noreferrer">Read the storage policy (opens a new tab)</a>.</p>
      </div>
      <button type="button" onClick={() => {
        try { localStorage.setItem(NOTICE_KEY, 'dismissed'); } catch { /* Works in memory when storage is blocked. */ }
        setDismissed(true);
      }}>Dismiss notice</button>
    </aside>
  );
}
